export const TimeOfDay = {
  Morning: 1,
  Afternoon: 2,
  Night: 3,
};
